/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".main-logo[_ngcontent-%COMP%]{width:80%}.invalid-feedback[_ngcontent-%COMP%]{display:block;padding-left:.5rem;margin-top:-1rem;margin-bottom:.8rem;color:#b31b29;color:var(--customTertiary)}"];
export { styles as styles };
